import { render, staticRenderFns } from "./CopyComponentModal.vue?vue&type=template&id=6a4c4b54&scoped=true&"
import script from "./CopyComponentModal.vue?vue&type=script&lang=js&"
export * from "./CopyComponentModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a4c4b54",
  null
  
)

export default component.exports